import { render, staticRenderFns } from "./ReportSuspectStats.vue?vue&type=template&id=2022f09e&scoped=true"
import script from "./ReportSuspectStats.vue?vue&type=script&lang=js"
export * from "./ReportSuspectStats.vue?vue&type=script&lang=js"
import style0 from "./ReportSuspectStats.vue?vue&type=style&index=0&id=2022f09e&prod&lang=css"
import style1 from "./ReportSuspectStats.vue?vue&type=style&index=1&id=2022f09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022f09e",
  null
  
)

export default component.exports